import { type EChartsExtensionInstallRegisters } from 'echarts/types/src/extension';
import { imgs } from '../../assets/dvWaterMarkImgs.js';
import { util } from 'echarts/core';

const waterMarkZ = 57;
const waterMarkId = '$DV_WATER_MARK';

function HiThinkWaterMark(option) {
  // 获取配置项中的水印设置
  const dvWaterMarkModel = option.dvWaterMark;
  if (!dvWaterMarkModel || dvWaterMarkModel.show === false) {
    return;
  }
  const waterMarkStyle = dvWaterMarkModel.style;
  if (waterMarkStyle) {
    if (dvWaterMarkModel.style.image === 'light') {
      dvWaterMarkModel.style.image = imgs['light'];
    }
    if (dvWaterMarkModel.style.image === 'dark') {
      dvWaterMarkModel.style.image = imgs['dark'];
    }
  } else {
    dvWaterMarkModel.style = { height: 10, width: 36 };
    dvWaterMarkModel.style.image = imgs['light'];
  }

  if (!dvWaterMarkModel.id) {
    dvWaterMarkModel.id = waterMarkId;
  }
  if (!dvWaterMarkModel.type) {
    dvWaterMarkModel.type = 'image';
  }
  if (!dvWaterMarkModel.z) {
    dvWaterMarkModel.z = waterMarkZ;
  }
  if (!dvWaterMarkModel.silent) {
    dvWaterMarkModel.silent = true;
  }
  // 如果没有graphic配置，添加一个
  if (!option.graphic) {
    option.graphic = { elements: [dvWaterMarkModel] };
  } else {
    // 如果graphic里面有elements
    if (option.graphic.elements) {
      option.graphic.elements.push(dvWaterMarkModel);
    } else {
      // 如果graphic是一个数组
      if (Array.isArray(option.graphic)) {
        option.graphic[0].elements.push(dvWaterMarkModel)
      } else {
        const elements = option.graphic;
        option.graphic.elements = {elements:[elements, dvWaterMarkModel]};
      }
    }
  }

}
export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerPreprocessor(function (...args) {
    const option = args[0];
    HiThinkWaterMark(option);
  });
}
